import {
	MyOrganizationEventCategory,
	Organization,
	USER_ROLES,
	UserOrganizationEducationalContent,
	UserOrganizationQuestionnaire,
	MyOrganizationBusinessCalendar,
	MyOrganizationBusinessParameters,
} from '@app/types/user'
import { RootState } from '@app/store'
import { CLINIC_STATUS } from '@app/types/common'
import { getUsersTimeLocation } from '@app/helpers'
import { MemberShipProduct } from '@app/types/membership'
import { TimeLocale } from '@app/hooks/contexts/timeController/timeControllerTypes'

export const selectUserId = (state: RootState): string =>
	state.appReducer.user?._id || ''

export const selectUserIdExtra = (state: RootState): string =>
	state.appReducer.user?.extra?.coachId || ''

export const selectUserName = (state: RootState): string =>
	state.appReducer.user?.personal?.name || ''

export const selectUserOrganizationId = (state: RootState): string =>
	state.appReducer.user?.extra?.organizationID || ''

export const selectUserOrgQuestionnaire = (
	state: RootState
): Array<UserOrganizationQuestionnaire> =>
	state.appReducer.user?.myOrganization?.questionnaire || []

export const selectUserOrgAccounts = (state: RootState): any =>
	state.appReducer.user?.myOrganization?.accounts || []

export const selectUserOrganization = (state: RootState): any =>
	state.appReducer.user?.myOrganization || {}

export const selectUserOrganizationName = (state: RootState): any =>
	state.appReducer.user?.myOrganization?.orgName || ''

export const selectUserOrganizationEducationalContent = (
	state: RootState
): Array<UserOrganizationEducationalContent> =>
	state.appReducer.user?.myOrganization?.educationalContent || []

export const selectOrganizationList = (state: RootState): Array<Organization> =>
	state.appReducer.user?.organizations || []

export const selectSystemAdminStatus = (state: RootState): boolean =>
	state.appReducer.user?.employment?.roles?.includes(
		USER_ROLES.SYSTEM_ADMIN
	) || false

export const selectOrgAdminStatus = (state: RootState): boolean =>
	state.appReducer.user?.employment?.roles?.includes(USER_ROLES.ORG_ADMIN) ||
	false

export const selectIsUserAdmin = (state: RootState): boolean => {
	const roles = state.appReducer.user?.employment?.roles || []

	return (
		roles.includes(USER_ROLES.ORG_ADMIN) ||
		roles.includes(USER_ROLES.SYSTEM_ADMIN) ||
		roles.includes(USER_ROLES.ACCOUNT_ADMIN)
	)
}

export const selectIsOrgOrSystemAdmin = (state: RootState): boolean => {
	const roles = state.appReducer.user?.employment?.roles || []

	return (
		roles.includes(USER_ROLES.ORG_ADMIN) ||
		roles.includes(USER_ROLES.SYSTEM_ADMIN)
	)
}

export const selectIsSysAdmin = (state: RootState): boolean => {
	const roles = state.appReducer.user?.employment?.roles || []

	return roles.includes(USER_ROLES.SYSTEM_ADMIN)
}

export const selectUserOrganizations = (
	state: RootState
): Array<Organization> => state.appReducer.user?.organizations || []

export const selectMembershipProducts = (
	state: RootState
): Array<MemberShipProduct> => {
	return (
		state.appReducer?.user?.myOrganization?.membershipEnrollment
			?.products || []
	)
}

export const selectOrganizationBusinessCalendar = (
	state: RootState
): MyOrganizationBusinessCalendar | undefined => {
	return state.appReducer.user?.myOrganization
		?.business_calender as MyOrganizationBusinessCalendar
}

export const selectOrganizationBusinessParameters = (
	state: RootState
): MyOrganizationBusinessParameters | undefined => {
	const businessParamteres = {
		coachCapacityLoad:
			state.appReducer.user?.myOrganization?.coachCapacityLoad,
		userToEngageInactiveSLA:
			state.appReducer.user?.myOrganization?.userToEngageInactiveSLA,
		userToEngageNewSLA:
			state.appReducer.user?.myOrganization?.userToEngageNewSLA,
	}
	return businessParamteres as MyOrganizationBusinessParameters
}

export const selectAccounts = (state: RootState): Array<string> => {
	return state.appReducer?.user?.myOrganization?.accounts || []
}

export const selectUserOrgId = (state: RootState): string =>
	state.appReducer?.user?.extra?.organizationID || ''

export const selectUserRoles = (state: RootState): Array<USER_ROLES> =>
	state.appReducer?.user?.employment?.roles || []

export const selectUserClinicStatus = (state: RootState): CLINIC_STATUS => {
	return state.appReducer?.user?.myOrganization?.internalClinic
		? CLINIC_STATUS.INTERNAL
		: CLINIC_STATUS.EXTERNAL
}

export const selectUserClinicEventCategories = (
	state: RootState
): Array<MyOrganizationEventCategory> =>
	state.appReducer?.user?.myOrganization?.eventCategoriesV2 || []

export const selectUsersTimeLocale = (state: RootState): TimeLocale =>
	getUsersTimeLocation(
		state.appReducer?.user?.localization?.dateConfiguration
	)
